import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  list: null,
  error: "",
};

export default function CompanyEmployee(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Company.Employee.SET_LIST:
      return { ...state, list: action.data };
    case Action.Company.Employee.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Company.Employee.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Company.Employee.CLEAR:
      return { ...state, list: null };
    default:
      return state;
  }
}
